/**
 * Booking enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
// Booking provider labels
export const bookingProviderLabels = {
    calendly: 'Calendly',
    timely: 'Timely',
    phorest: 'Phorest',
    fresha: 'Fresha',
};
export const bookingProviderValues = Object.keys(bookingProviderLabels);
/**
 * Amenities shown in the "Additional information" block of the public venue
 * page. Stored as a string[] on `organization.amenities`; the venue page maps
 * each key through these labels, and the dashboard renders the same list as
 * checkboxes. Adding a key here is the ONLY change needed to offer a new one.
 */
export const venueAmenityLabels = {
    instant_confirmation: 'Instant confirmation',
    pet_friendly: 'Pet-friendly',
    kid_friendly: 'Kid-friendly',
    lgbtq_friendly: 'LGBTQ+ friendly',
    wheelchair_accessible: 'Wheelchair accessible',
    parking_available: 'Parking available',
    free_wifi: 'Free Wi-Fi',
    card_payments: 'Card payments accepted',
};
export const venueAmenityValues = Object.keys(venueAmenityLabels);
/**
 * Booking window — which calendar days, counted
 * in the ORG's timezone from today, customers may book online. Min 0 allows
 * same-day bookings; max is inclusive. Staff booking is never restricted.
 */
export const BOOKING_MIN_DAYS_AHEAD_DEFAULT = 0;
export const BOOKING_MIN_DAYS_AHEAD_LIMIT = 7;
export const BOOKING_MAX_DAYS_AHEAD_DEFAULT = 60;
export const BOOKING_MAX_DAYS_AHEAD_LIMIT = 365;
/** `YYYY-MM-DD` + whole days, in pure calendar arithmetic (no DST drift). */
export function addDaysToDayKey(dayKey, days) {
    const date = new Date(`${dayKey}T00:00:00Z`);
    date.setUTCDate(date.getUTCDate() + days);
    return date.toISOString().slice(0, 10);
}
/**
 * Resolve the bookable day range for "now" in `timeZone`. Day keys compare
 * correctly as strings, so callers test a slot with `isDayInBookingWindow`.
 */
export function bookingWindowDays(settings, timeZone, now = new Date()) {
    // en-CA formats as YYYY-MM-DD.
    const today = new Intl.DateTimeFormat('en-CA', {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(now);
    return {
        firstDay: addDaysToDayKey(today, settings.minDaysAhead),
        lastDay: addDaysToDayKey(today, settings.maxDaysAhead),
    };
}
export function isDayInBookingWindow(dayKey, window) {
    return dayKey >= window.firstDay && dayKey <= window.lastDay;
}
//# sourceMappingURL=booking.js.map